export default function calculateChange(receiptPrices) {
  let change = 0;
  let round_adj = 0;
  let total = 0;

  total = Math.round(receiptPrices.total * 20) / 20;
  round_adj = total - (receiptPrices.subtotal + receiptPrices.sst);
  change = receiptPrices.cash - total;

  return {
    total: total,
    change: change,
    round_adj: round_adj,
  };
}
